import { Component, Input, OnInit } from "@angular/core";
import { FilterCardWithCode } from "app/modules/dashboard/constants/filters";

@Component({
  selector: "kl-units-list",
  templateUrl: "./units-list.component.html",
  styleUrls: ["./units-list.component.scss"],
})
export class UnitListComponent implements OnInit {
  filterSelectItems = FilterCardWithCode;
  @Input() tabId: string;
  @Input() modalId: string;

  constructor() {}

  ngOnInit() {}
}
